import styleInject from 'style-inject';

var css_248z = ".ExpandableCard-module_expandButton__sRBaz{cursor:pointer}@media (max-width:640px){.ExpandableCard-module_expandButton__sRBaz{display:none}}";
var styles = {"expandButton":"ExpandableCard-module_expandButton__sRBaz"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXhwYW5kYWJsZUNhcmQubW9kdWxlLnNjc3MuanMiLCJzb3VyY2VzIjpbXSwic291cmNlc0NvbnRlbnQiOltdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7OzsifQ==
